import { render, staticRenderFns } from "./BaseCardTransitionGroup.vue?vue&type=template&id=6d05fc57"
import script from "./BaseCardTransitionGroup.vue?vue&type=script&lang=js"
export * from "./BaseCardTransitionGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports